<mat-card>
    <mat-card-content fxLayout="column">
        <div fxFlex="100" fxLayout="row" class="title" fxLayoutAlign="space-between center">
            <title-back [addTitle]="true" [Title]="'Ops Date Changed List'" (back)="back()"></title-back>
            <div class="records">
                <mat-form-field appearance="outline">
                    <input matInput (ngModelChange)="applyFilter($event)" placeholder="Search" ngModel>
                    <i matSuffix class="flaticon-search"></i>
                </mat-form-field>
                <!-- <logzy-reports-table [downloadButtons]="true" [pageName]="'charge_master'"></logzy-reports-table> -->
                <button mat-raised-button (click)="navigateToNewRequest()" class="sleekBtn Save">New Request</button>
            </div>
        </div>
        <div class="setTable">
            <ng-container>
                <mat-table [dataSource]="approvalList">
                    <ng-container [matColumnDef]="'request_number'">
                        <mat-header-cell *matHeaderCellDef> Request No</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                            <!-- <span class="mobile-label ">Request No:</span> -->
                            <span class="requestNumber">
                            {{data?.booking.request_number == null ? "-" : data?.booking.request_number}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'booking_type'">
                        <mat-header-cell *matHeaderCellDef> Booking Type</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 " style="cursor:pointer" (click)="view(data)">
                            <span class="natureChip">
                                <!-- [class]="data?.transaction_type ? data?.transaction_type : 'use'" -->
                                {{getNatureOfRequest(data)}}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'requested_by'">
                        <mat-header-cell *matHeaderCellDef> Requested By</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <!-- <span class="mobile-label">Request Date:</span> -->
                            <span>
                                {{data?.requested_by.first_name}} {{data?.requested_by.last_name}}
                            </span>
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'request_date'">
                        <mat-header-cell *matHeaderCellDef> Requested Date</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <!-- <span class="mobile-label">Request Date:</span> -->
                            <span>
                                {{data?.created_at | date :"dd-MM-yyyy h:mm a"}}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'status'">
                        <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                            <!-- <span>{{data.status_display}}</span> -->
                            <mat-chip [style.background-color]="getBackgroundColor(data?.status_display)"
                                      style="color:white">
                                {{data?.status_display == null ? "-" : data?.status_display}}
                            </mat-chip>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'ops_request_type'">
                        <mat-header-cell *matHeaderCellDef> OPS Request Type</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12">
                            <span>{{data.latest_active_approval?.title ?? '-'}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'action'">
                        <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <div class="actions">
                                <i class="flaticon-view" (click)="view(data)"></i>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayColumns;" [class.blur]="update"></mat-row>
                </mat-table>
                <div class="loadingData" [class.d-none]="!update">
                    <logzy-gear-loader></logzy-gear-loader>

                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users" [pageSize]="10"
                               [length]="pageLength" (page)="pageChanged($event)" #paginator></mat-paginator>
            </ng-container>
        </div>
    </mat-card-content>
</mat-card>